import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Hotlines } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class HotlinesModule extends VuexModule {
    @Action
    [Hotlines.findPageHotlines](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post( `/api/v1/hotlines/search`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Hotlines.findPageHotlinesByType](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.get( `/api/v1`,`hotlines?pageNum=${values.pageNum}&pageSize=${values.pageSize}&idType=${values.typeId}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Hotlines.findHotlinesById](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/api/v1`,`hotlines/${values}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Hotlines.saveHotlines](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/api/v1/hotlines`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Hotlines.updateHotlines](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.put(`/api/v1/hotlines/${values.id}`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Hotlines.deleteHotlinesById](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.delete(`/api/v1/hotlines/${values}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}